import { useForm } from 'react-hook-form'

export default function useScanForm(initialValues = {}) {
  const defaultValues = {
    area: '',
    order_and_id: '',
    operator: '',
    machine: '',
    order_note: '',
    related_ids: [],
  }
  const defaultValuesWithInitial = { ...defaultValues, ...initialValues }
  return useForm({ defaultValues: defaultValuesWithInitial })
}
